module.exports = __webpack_public_path__ + "img/keyboard_V.3c4a6fff.png";